export class CpfCnpjUtil {
  static format(document: string | number | null | undefined): string {
    if (document === null || document === undefined) {
      return '';
    }

    const digits = String(document).replace(/\D/g, '');

    if (digits.length === 11) {
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    if (digits.length === 14) {
      return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    return String(document);
  }
}
